import CollectionNames from 'constant/CollectionNames';
import { InstanceContainer } from './InstanceBinding';
import { MemoryDb } from 'minimongo';
import { subscribe } from '@trlogic/client-js';
import Injectables from '../../constant/Injectables';
import NavigationUtil from '../../util/NavigationUtil';

export const registerCollections = () => {
  const localDb: MemoryDb = InstanceContainer.get(Injectables.LOCAL_DB);
  Object.values(CollectionNames).forEach((collection) => {
    localDb.addCollection(collection);
    //InstanceContainer.bind(collection).toConstantValue(new Collection(collection));
  });

  localDb.addCollection(`audit_log_ui_${NavigationUtil.getTenant()}_*`);
  localDb.addCollection(`case_event_log_${NavigationUtil.getTenant()}_*`);
  localDb.addCollection(`transaction_chat_log_${NavigationUtil.getTenant()}`);
  localDb.addCollection(`entity_chat_log_${NavigationUtil.getTenant()}`);
  localDb.addCollection(`risk_transaction_log_${NavigationUtil.getTenant()}_*`);
  localDb.addCollection(`kyc_individual_log_${NavigationUtil.getTenant()}`);
  localDb.addCollection(`kyc_entity_log_${NavigationUtil.getTenant()}`);

  setInterval(() => {
    //console.clear();
    //console.table(Object.values(subscriptionContext.getSubscriptions()))
  }, 500);

  window.onmessage = (event) => {
    if (event.data && typeof event.data == 'object' && event.data?.type == 'printSubscription') {
      console.log(event);
      console.table(Object.values(subscriptionContext.getSubscriptions()));
    }
  };
  // @ts-ignore
  global['printSub'] = () => {
    console.table(Object.values(subscriptionContext.getSubscriptions()));
  };
  // @ts-ignore
  global['printDuration'] = () => {
    console.table(subscriptionContext.getDurations());
  };
  // @ts-ignore
  global['printCollection'] = (collectionName: string) => {
    localDb.collections[collectionName]?.find({}).fetch((success: any) => {
      console.log(success);
    });
  };
  // @ts-ignore
  global['printCollections'] = () => {
    Promise.all(
      Object.entries(localDb.collections)
        .filter((c) => subscriptionContext.getSubscriptionsByCollection(c[0]).length != 0)
        .map(([key, value]) => {
          return new Promise((resolve, reject) => {
            value.find({}).fetch((success: any) => {
              resolve([key, success]);
            });
          });
        }),
    ).then((data) => {
      console.table(data);
    });
  };
  const subscriptionContext = new subscribe.SocketSubscriptionContext(localDb, InstanceContainer.get(Injectables.SOCKET_CLIENT), {
    waitMs: 10,
    triggerMs: 5,
    defaultDriver: 'postgres',
  });
  subscribe.Formica.initContext(subscriptionContext);
  InstanceContainer.bind(Injectables.SUBSCRIPTION_CONTEXT).toConstantValue(subscriptionContext);
};
